import {AssessmentIcon, Box, Chip, DateRangeIcon, DnsIcon, InsightsIcon, PermIdentityIcon, styled} from '../../../ui-library';
import {Card} from '@mui/material';

export const CardsBox = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 100%;
    margin-top: 30px;
`;


export const VersionChip = styled(Chip)`
    & .MuiChip-label{
    }

`;


export const RowBox = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
`;
export const SpaceBetweenBox = styled(RowBox)`
    justify-content: space-between;
`;
export const TitleBox = styled(RowBox)`
    gap: 8px;
`;
export const StatusBox = styled(RowBox)`
    gap: 17px;
`;

export const ClassesBox = styled(RowBox)`
    margin-top: 16px;
    gap: 11px;
`;


export const DetailsBox = styled(RowBox)`
    margin-top: 8px;
    gap: 32px;
`;

export const ClassChip = styled(Chip)`
    height: 30px;
    & .MuiChip-label{
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.16px;
  }
`;

export const InTrainClassChip = styled(ClassChip)`
    background-color: ${({ theme }) => theme.palette.grey[200]};
    & .MuiChip-label{
        color: ${({ theme }) => theme.palette.grey[500]};
  }
`;

export const StyledCard = styled(Card)`
    border: 1px solid ${({ theme }) => theme.palette.grey[200]};
    box-shadow: none;
`;

export const IconBox = styled(Box)`
    display: flex;
    gap: 8px;
    flex-direction: row;
    align-items: center;
    color: ${({ theme }) => theme.palette.grey[700]}
`;

export const StyledPermIdentityIcon = styled(PermIdentityIcon)`
  font-size: 16px;
`;

export const StyledDnsIcon = styled(DnsIcon)`
  font-size: 16px;
`;

export const StyledAssessmentIcon = styled(AssessmentIcon)`
  font-size: 16px;
`;

export const StyledDateRangeIcon = styled(DateRangeIcon)`
  font-size: 16px;
`;

export const StyledInsightsIcon = styled(InsightsIcon)`
  font-size: 16px;
`;

export const AccuracyBox = styled(Box)`
    display: flex;
    justify-content: right;
`;


